// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2OzLW","invertedOverlay":"Modal_invertedOverlay__x1jDG","fadeIn":"Modal_fadeIn__u5qdB","fadeOut":"Modal_fadeOut__y86nu"};